module.exports = {"title":"Hub Settings","datatable":{"name":"Name","outlets":"Stations"}};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en_sentinel/hub_settings.php
// module id = lbSx
// module chunks = 113